import { Box, Stack, useMediaQuery } from "@mui/material";
import { modalHide } from "app/App/actions";
import trans from "helpers/trans";
import { FC } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Button, Modal, ModalActions, ModalContent, ModalTitle } from "ui";
interface ITermssModal {
    content: string;
}

const TermsModal: FC<ITermssModal> = ({ content }) => {
    const dispatch = useDispatch();
    const { primary } = useSelector(
        (state: any) => state.app.settings.customization.button
    );

    const smallScreen = useMediaQuery((theme: any) =>
        theme.breakpoints.down("tablet")
    );
    const handleClose = () => {
        dispatch(modalHide("TermsModal"));
    };
    return (
        <Modal
            maxWidth="sm"
            fullWidth
            open
            fullScreen={smallScreen}
            scroll="paper"
            sx={{
                "& .MuiPaper-root": {
                    maxWidth: 745,
                },
            }}
        >
            <ModalTitle onClose={handleClose}></ModalTitle>
            <ModalContent
                sx={{
                    pt: 0,
                    px: 4,
                    display: "flex",
                    flexDirection: "column",
                    pb: 0,
                    gap: 2,
                }}
            >
                <Box
                    sx={{
                        fontSize: 14,
                        color: "#02263A",
                        wordBreak: "break-word",
                        display: "inline-block",
                    }}
                    dangerouslySetInnerHTML={{
                        __html: content.replace(/\n/g, "<br/>"),
                    }}
                />
            </ModalContent>
            <ModalActions sx={{ pt: 3, px: 4, pb: 3.75 }}>
                <Box
                    display="flex"
                    width="100%"
                    textAlign="right"
                    flexDirection="column"
                    justifyContent="center"
                    gap={3}
                >
                    <Stack
                        direction="row"
                        sx={{
                            marginLeft: "0!important",
                            width: "100%",
                            gap: 1,
                            p: 0,
                        }}
                    >
                        <Button
                            onClick={handleClose}
                            sx={{
                                width: "100%",
                                fontFamily: "'Source Sans 3'",
                                fontWeight: 600,
                                fontSize: 18,
                                height: 48,
                                lineHeight: 1.4,
                                borderRadius: 1.5,
                                backgroundColor: primary.background,
                                color: primary.color,
                                "&:hover": {
                                    backgroundColor: primary.hover_background,
                                    color: primary.hover_color,
                                },
                            }}
                        >
                            {trans("global.button.close")}
                        </Button>
                    </Stack>
                </Box>
            </ModalActions>
        </Modal>
    );
};

export default TermsModal;
